import { CallEvent } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';

const handleCallEnded = (
  webPhoneService: IWebPhoneService,
  newCallEvent: CallEvent,
  logger: IAppLogger,
) => {
  logger.info(
    `Call ended: ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );
  appManager.events.emit('phone.call.ended', newCallEvent);
};

export default handleCallEnded;
